import * as moment from 'moment'
import 'moment/locale/ru'

moment.locale('ru')

window.moment = moment

export { moment }
